var __typeError = (msg) => {
  throw TypeError(msg);
};
var __accessCheck = (obj, member, msg) => member.has(obj) || __typeError("Cannot " + msg);
var __privateGet = (obj, member, getter) => (__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var __privateAdd = (obj, member, value) => member.has(obj) ? __typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var __privateSet = (obj, member, value, setter) => (__accessCheck(obj, member, "write to private field"), setter ? setter.call(obj, value) : member.set(obj, value), value);
var __privateMethod = (obj, member, method) => (__accessCheck(obj, member, "access private method"), method);
var _eventController, _indicator, _indicatorFrame, _indicatorReadyFrame, _indicatorResizeObserver, _tabList, _ResultsTab_instances, setupIndicator_fn, scheduleIndicatorSync_fn, syncIndicator_fn, scheduleIndicatorReady_fn, resetIndicatorReady_fn, bindClickHandler_fn, setActiveTab_fn, fetchResults_fn;
import "./toggle-group-CJtq6Wo8.js";
class ResultsTab extends HTMLElement {
  constructor() {
    super(...arguments);
    __privateAdd(this, _ResultsTab_instances);
    __privateAdd(this, _eventController, null);
    __privateAdd(this, _indicator, null);
    __privateAdd(this, _indicatorFrame, null);
    __privateAdd(this, _indicatorReadyFrame, null);
    __privateAdd(this, _indicatorResizeObserver, null);
    __privateAdd(this, _tabList, null);
  }
  connectedCallback() {
    var _a;
    (_a = __privateGet(this, _eventController)) == null ? void 0 : _a.abort();
    __privateSet(this, _eventController, new AbortController());
    __privateMethod(this, _ResultsTab_instances, bindClickHandler_fn).call(this);
    __privateMethod(this, _ResultsTab_instances, setupIndicator_fn).call(this);
  }
  disconnectedCallback() {
    var _a, _b;
    (_a = __privateGet(this, _eventController)) == null ? void 0 : _a.abort();
    __privateSet(this, _eventController, null);
    (_b = __privateGet(this, _indicatorResizeObserver)) == null ? void 0 : _b.disconnect();
    __privateSet(this, _indicatorResizeObserver, null);
    if (__privateGet(this, _indicatorFrame)) cancelAnimationFrame(__privateGet(this, _indicatorFrame));
    __privateSet(this, _indicatorFrame, null);
    __privateMethod(this, _ResultsTab_instances, resetIndicatorReady_fn).call(this);
  }
}
_eventController = new WeakMap();
_indicator = new WeakMap();
_indicatorFrame = new WeakMap();
_indicatorReadyFrame = new WeakMap();
_indicatorResizeObserver = new WeakMap();
_tabList = new WeakMap();
_ResultsTab_instances = new WeakSet();
setupIndicator_fn = function() {
  __privateSet(this, _tabList, this.querySelector(".page-result-tabs-content-inner:not(.result-tabs-toggle-group)"));
  __privateSet(this, _indicator, this.querySelector("[data-result-tabs-indicator]"));
  if (!__privateGet(this, _tabList) || !__privateGet(this, _indicator)) return;
  __privateSet(this, _indicatorResizeObserver, new ResizeObserver(() => __privateMethod(this, _ResultsTab_instances, scheduleIndicatorSync_fn).call(this)));
  __privateGet(this, _indicatorResizeObserver).observe(__privateGet(this, _tabList));
  __privateGet(this, _tabList).querySelectorAll(".result-tabs-btn-content").forEach((item) => {
    __privateGet(this, _indicatorResizeObserver).observe(item);
  });
  __privateMethod(this, _ResultsTab_instances, scheduleIndicatorSync_fn).call(this);
};
scheduleIndicatorSync_fn = function() {
  if (__privateGet(this, _indicatorFrame)) return;
  __privateSet(this, _indicatorFrame, requestAnimationFrame(() => {
    __privateSet(this, _indicatorFrame, null);
    if (this.isConnected) __privateMethod(this, _ResultsTab_instances, syncIndicator_fn).call(this);
  }));
};
syncIndicator_fn = function() {
  if (!__privateGet(this, _tabList) || !__privateGet(this, _indicator)) return;
  const activeItem = __privateGet(this, _tabList).querySelector(".result-tabs-btn-content.active");
  if (!activeItem) {
    __privateMethod(this, _ResultsTab_instances, resetIndicatorReady_fn).call(this);
    return;
  }
  const containerRect = __privateGet(this, _tabList).getBoundingClientRect();
  const itemRect = activeItem.getBoundingClientRect();
  if (containerRect.width === 0 || itemRect.width === 0) return;
  const paddingBottom = parseFloat(getComputedStyle(__privateGet(this, _tabList)).paddingBottom) || 0;
  const left = itemRect.left - containerRect.left + __privateGet(this, _tabList).scrollLeft;
  const bottom = itemRect.bottom - containerRect.top + __privateGet(this, _tabList).scrollTop + paddingBottom;
  const scale = itemRect.width / containerRect.width;
  const transform = `translate3d(${left}px, ${bottom}px, 0) translateY(-100%) scaleX(${scale})`;
  if (__privateGet(this, _indicator).style.transform !== transform) {
    __privateGet(this, _indicator).style.transform = transform;
  }
  __privateMethod(this, _ResultsTab_instances, scheduleIndicatorReady_fn).call(this);
};
scheduleIndicatorReady_fn = function() {
  if (this.dataset.resultTabsIndicatorTransitionReady === "true") return;
  if (__privateGet(this, _indicatorReadyFrame)) cancelAnimationFrame(__privateGet(this, _indicatorReadyFrame));
  __privateSet(this, _indicatorReadyFrame, requestAnimationFrame(() => {
    __privateSet(this, _indicatorReadyFrame, requestAnimationFrame(() => {
      var _a;
      if (!this.isConnected || !((_a = __privateGet(this, _tabList)) == null ? void 0 : _a.querySelector(".result-tabs-btn-content.active"))) {
        __privateSet(this, _indicatorReadyFrame, null);
        return;
      }
      this.dataset.resultTabsIndicatorReady = "true";
      __privateSet(this, _indicatorReadyFrame, requestAnimationFrame(() => {
        __privateSet(this, _indicatorReadyFrame, null);
        if (!this.isConnected || this.dataset.resultTabsIndicatorReady !== "true") return;
        this.dataset.resultTabsIndicatorTransitionReady = "true";
      }));
    }));
  }));
};
resetIndicatorReady_fn = function() {
  if (__privateGet(this, _indicatorReadyFrame)) cancelAnimationFrame(__privateGet(this, _indicatorReadyFrame));
  __privateSet(this, _indicatorReadyFrame, null);
  this.removeAttribute("data-result-tabs-indicator-ready");
  this.removeAttribute("data-result-tabs-indicator-transition-ready");
};
bindClickHandler_fn = function() {
  var _a;
  this.addEventListener(
    "click",
    (e) => {
      const tab = e.target.closest("[data-tab-type]");
      if (!tab) return;
      e.preventDefault();
      const type = tab.dataset.tabType;
      if (!type) return;
      __privateMethod(this, _ResultsTab_instances, setActiveTab_fn).call(this, tab);
      if (this.dataset.placeholder === "true") return;
      const searchUrl = Theme.routes.search_url || "/search";
      const currentParams = new URLSearchParams(window.location.search);
      const params = new URLSearchParams();
      for (const [
        key,
        value
      ] of currentParams.entries()) {
        if (!key.startsWith("filter.") && key !== "sort_by" && key !== "type" && key !== "page") {
          params.append(key, value);
        }
      }
      if (type !== "all") params.set("type", type);
      else if (tab.dataset.tabTypes) params.set("type", tab.dataset.tabTypes);
      if (!params.has("q")) {
        params.set("q", this.dataset.searchTerm || "");
      }
      const url = `${searchUrl}?${params.toString()}`;
      __privateMethod(this, _ResultsTab_instances, fetchResults_fn).call(this, url);
    },
    { signal: (_a = __privateGet(this, _eventController)) == null ? void 0 : _a.signal }
  );
};
/**
 * Update active tab styling
 */
setActiveTab_fn = function(clickedBtn) {
  var _a;
  this.querySelectorAll(".result-tabs-btn-content").forEach((tab) => {
    var _a2;
    tab.classList.remove("active");
    (_a2 = tab.querySelector(".result-tabs-btn-content-inner")) == null ? void 0 : _a2.classList.remove("active");
  });
  clickedBtn.classList.add("active");
  const tabInner = (_a = clickedBtn.closest(".result-tabs-btn-content")) == null ? void 0 : _a.querySelector(".result-tabs-btn-content-inner");
  if (tabInner) {
    tabInner.classList.add("active");
  }
  __privateMethod(this, _ResultsTab_instances, scheduleIndicatorSync_fn).call(this);
};
fetchResults_fn = async function(url) {
  const facetsForm = document.querySelector("facets-form-component");
  if (facetsForm && typeof facetsForm.updateFiltersByURL === "function") {
    facetsForm.updateFiltersByURL(url, true);
    return;
  }
  window.location.href = url;
};
if (!customElements.get("results-tab")) {
  customElements.define("results-tab", ResultsTab);
}
